module.exports = __webpack_public_path__ + "media/op_fail.78cc01b5.mp3";